import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center p-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-50" }, null, -1)
const _hoisted_3 = { class: "relative mx-auto z-10 rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:w-2/5 sm:p-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark-blue text-2xl font-roboto text-center mb-3" }, " Please Select Financial / Tax Year End ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-dark-blue text-base text-center" }, " If you continue, the Section 18A tax certificate, for the selected year will be available and donors will be notified accordingly. ", -1)
const _hoisted_6 = { class: "mt-2 w-full relative" }
const _hoisted_7 = { class: "flex justify-between mt-6" }

import {computed} from 'vue';
import {taxYears} from "@/helpers/utilities/utility";
import Dropdown from "@/components/Atomic/AQuarks/Dropdown.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TaxCertificateModal',
  props: {
  isTaxCertificateModalOpen: Boolean,
  taxYear: String,
},
  emits: ['close', 'continue'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit

const years = computed(() => {
  return taxYears(2022).map<string>(taxYear => taxYear.toString())
})


return (_ctx: any,_cache: any) => {
  return (__props.isTaxCertificateModalOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(Dropdown, {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (__props.taxYear = $event)),
              placeholder: 'Select Option',
              "model-value": __props.taxYear,
              options: years.value
            }, null, 8, ["model-value", "options"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
              class: "flex items-center px-5 py-2 rounded-md shadow-md bg-transparent text-dark-blue border border-dark-blue"
            }, " Cancel "),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('continue', __props.taxYear))),
              class: _normalizeClass([!__props.taxYear ? 'disabled bg-gray-500' : 'bg-light-blue', "flex items-center px-5 py-2 rounded-md shadow-md text-white"])
            }, " Continue ", 2)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})